import { styled } from '@mui/material/styles';

const StyledTable = styled('div')`
  width: 100%;
  max-width: 1200px;
  flex-grow: 1;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 22px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
  padding: 1.25rem 1rem 1rem;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    margin: 0 auto;
    padding: 1.5rem 1.25rem 1.25rem;
  }

  ${({ theme }) => theme.breakpoints.up('xl')} {
    max-width: 1360px;
  }
`;

export default StyledTable;
